import script from "./WhyChooseUs.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&setup=true&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=2eed7772&scoped=true&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eed7772"]])

export default __exports__